<template>
  <div>
    <SellHeader :img_header="header_image" header="คำสั่งซื้อ" link_back="sell/orderretailcustomers"/>
    <Order_retail_detail/>
  </div>
</template>

<script>
import SellHeader from "@/components/admin/sell/header_sell/SellHeader";
import HeaderImage from "@/assets/clipboard_2.png";
import Order_retail_detail from "@/components/admin/sell/Order_retail_detail";
export default {
  name: "OrderRetailDetail",
  components: {
    Order_retail_detail,
    SellHeader
  },
  data() {
    return {
      header_image: HeaderImage
    }
  }
}
</script>

<style scoped>

</style>
